import __request__ from "routing/request";
export function getACS(SAMLResponse, RelayState, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.security/saml/acs", null, { "SAMLResponse": SAMLResponse, "RelayState": RelayState }, {
    "Accept": []
  }, requestOptions);
}
export function postACS(requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.security/saml/acs", null, {}, {
    "Accept": []
  }, requestOptions);
}
export function initiateLogin(relayState, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.security/saml/login", null, { "relayState": relayState }, {
    "Accept": []
  }, requestOptions);
}
export function postLogout(requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.security/saml/logout", null, {}, {
    "Accept": []
  }, requestOptions);
}
export function getLogout(SAMLRequest, RelayState, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.security/saml/logout", null, { "SAMLRequest": SAMLRequest, "RelayState": RelayState }, {
    "Accept": []
  }, requestOptions);
}
